import { Injectable } from '@angular/core';
import { HttpService } from '../../../shared/services/http/http-client.service';
import { environment } from '../../../../environments/environment';

const API = environment.url_server;

@Injectable({
  providedIn: 'root'
})
export class GestaoFinanceiraService {

  constructor(
    private http: HttpService
  ) { }

  buscaCliente(data: any, successHandle: Function, errorHandle: Function) {

    this.http.doGet('/enterprise/financial/block', data, successHandle, errorHandle);

  }

  salvarBloqueioFinanceiro(data: any, successHandle: Function, errorHandle: Function) {

    this.http.doPost('/enterprise/financial/block', data, successHandle, errorHandle);

  }

  findFaturaRecebtoEfetivo(data: any, successHandle: Function, errorHandle: Function) {

    this.http.doGet('/enterprise/findFaturaRecebtoEfetivo', data, successHandle, errorHandle);

  }

  findFinancialBlockList(data: any, successHandle: Function, errorHandle: Function) {

    this.http.doGet('/enterprise/findFinancialBlock', data, successHandle, errorHandle);

  }

  hasFinancialBlock(data: any, successHandle: Function, errorHandle: Function) {
    this.http.doGet('/enterprise/hasFinancialBlock', data, successHandle, errorHandle);
  }

}
